export default "__VITE_ASSET__SBSQN15K__"